import CommonRouterSection from '@/components/layout/CommonRouterSection'

export default {
  path: '/signup',
  name: 'signup-index',
  component: CommonRouterSection,
  redirect: '/signup/usertype',
  children: [
    {
      path: 'usertype',
      name: 'signup-uper-type-index',
      component: () => import("@/views/signup/UserType.vue")
    },
    {
      path: 'agent/email',
      name: 'signup-agent-email-index',
      component: () => import("@/views/signup/AgentEmail.vue")
    },
    {
      path: 'agent/regist/*',
      name: 'signup-agent-regist-index',
      component: () => import("@/views/signup/AgentRegist.vue")
    },
    {
      path: 'agent/registFail/*',
      name: 'signup-agent-regist-fail-index',
      component: () => import("@/views/signup/AgentRegistFail.vue")
    },
    {
      path: 'agent/registSuccess',
      name: 'signup-agent-regist-success-index',
      component: () => import("@/views/signup/AgentRegistSuccess.vue")
    },
    {
      path: 'common/email',
      name: 'signup-common-email-index',
      component: () => import("@/views/signup/CommonEmail.vue")
    },
    {
      path: 'common/individualregist/*',
      name: 'signup-common-individual-regist-index',
      component: () => import("@/views/signup/CommonIndividualRegist.vue")
    },
    {
      path: 'common/companyregist/*',
      name: 'signup-common-company-regist-index',
      component: () => import("@/views/signup/CommonCompanyRegist.vue")
    },
    {
      path: 'common/registFail/*',
      name: 'signup-common-regist-fail-index',
      component: () => import("@/views/signup/CommonRegistFail.vue")
    },
    {
      path: 'common/registSuccess',
      name: 'signup-common-regist-success-index',
      component: () => import("@/views/signup/CommonRegistSuccess.vue")
    },
  ]
}
